// extracted by mini-css-extract-plugin
module.exports = {"category":"style_category-30rLh","label":"style_label-Xl-SL","all":"style_all-3xhQv","checkbox":"style_checkbox-1aYlZ"};